<script setup>
import { cn } from "@/shared/lib/utils";

const props = defineProps({
  class: { type: [String, Object, Array], default: undefined },
});
</script>

<template>
  <tbody data-slot="table-body" :class="cn('', props.class)">
    <slot />
  </tbody>
</template>
